import React, { useEffect, useState } from 'react'
import "react-datepicker/dist/react-datepicker.css";
import SmallModalLayout from '../../components/Common/SmallModalLayout';
import MemberAvailability from './MemberAvailability';
import Select from 'react-select';
import Loader from '../Utilities/Loader';
import { toast } from 'react-toastify';
import TechnologyModalLayout from '../Common/TechnologyModalLayout';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';


const Member = ({ data }) => {

    const [open, SetOpenModal] = useState(false);
    const [errorOpen, SetErrorOpenModal] = useState(false);
    const [selectedMember, setSelectedMember] = useState({});
    const [memberData, setMemberData] = useState([]);
    const [allMemberData, setAllMemberData] = useState([]);
    const [invitedMember, setInvitedMember] = useState("");
    const [isUpdateLoading, setUpdateLoading] = useState(false);
    const [isToggleLoading, setToggleLoading] = useState(false);
    const dispatch = useDispatch()
    const membersListData = useSelector(state => state.projectDetails.membersList)

    const getMembersListData = async ({ project_id }) => {
        try {
            await dispatch.projectDetails.getMembersList({ project_id });
        } catch (err) {
            console.log("err", err);
        }
    }

    const toggleClass = 'transform translate-x-5 transition delay-150 duration-150 ease-linear';

    useEffect(() => {
        if (data && data.project && data.project._id) {
            getMembersListData({ project_id: data.project._id });
            const listAllMembersData = async () => {
                const responseListData = await dispatch.people.listAllMembers();
                if (responseListData && responseListData.data) {
                    setAllMemberData(responseListData.data)
                }
            }
            listAllMembersData();
        }
    }, [data]);

    useEffect(() => {
        setMemberData(membersListData.data);
    }, [membersListData]);

    const handleModal = () => {
        SetOpenModal(!open);
    }

    const handleErrorModal = () => {
        SetErrorOpenModal(!errorOpen);
    }

    const updateStatus = async (item, ind) => {
        try {
            setToggleLoading(item.user_id._id);
            let status = item.status === 'active' ? 'deleted' : 'active';
            await dispatch.projects.inviteMember([{ user_id: item.user_id._id, project_id: data.project._id, status }]);
            await getMembersListData({ project_id: data.project._id });
            setToggleLoading(false);
        } catch (err) {
            //toast.error(err.error);
            setToggleLoading(false);
            SetErrorOpenModal(true);
        }
    }

    const InviteMember = async () => {
        try {

            if (invitedMember && invitedMember.value) {
                setUpdateLoading(true);
                const responseData = await dispatch.projects.inviteMember([{ user_id: invitedMember.value, project_id: data.project._id, status: 'active', invitation: true }]);
                await getMembersListData({ project_id: data.project._id });
                setUpdateLoading(false);
                if (responseData.data.success) {
                    toast.success("Member Invited successfully");
                }
            }
        } catch (err) {
            toast.error(err.error);
            setUpdateLoading(false);
        }
    }

    return (
        <>
            <div className="flex items-center lg:flex-row justify-between">
                <h2 className="text-base text-black font-semibold mb-5">Team Members</h2>
                <div>
                    <div className="flex">
                        <div className="mb-8 relative ml-2" >
                            <Select
                                className='pl-0 w-52 medium-selectbox appearance-none focus:outline-none focus:border-primary-navyBluew transition delay-150 duration-150 ease-linear text-xs md:text-base border rounded-md w-full placeholder-secondary-grey-300 text-secondary-grey-300 font-normal border-secondary-grey-400'
                                name="member"
                                value={invitedMember}
                                isSearchable={true}
                                isClearable={true}
                                classNamePrefix="dropdownSelect"
                                options={allMemberData.map((project) => ({ label: `${project.first_name} (${project.designation && project.designation.name})`, value: project._id }))}
                                placeholder="Select Member"
                                onChange={(e) => {
                                    setInvitedMember(e);

                                }}
                            />
                        </div>

                        <div className="ml-2">
                            <button disabled={isUpdateLoading} onClick={() => { InviteMember() }} className="font-title flex items-center  bg-primary-navyBlue text-white text-xs md:text-tiny font-medium transition duration-300 ease-out hover:bg-opacity-80 px-4 rounded-md h-[38px]">Invite Member
                                {isUpdateLoading ? <Loader /> : null}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid lg:grid-cols-2 xl:grid-cols-2  2xl:grid-cols-3 gap-4">

                {memberData && memberData.length ? memberData.map((item, index) =>
                    <div key={index} className={`${item.status === "active" ? "" : ""} border border-200 rounded-md p-4 relative shadow-300`}>
                        <div className="flex w-full">
                            <div className="w-16">

                                <div className="w-12 h-12 bg-secondary-blue-500 rounded-full mr-4 flex items-center justify-center">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.68649 9.90273V9.4416V8.46963V8.30907L9.75222 8.16258C9.84675 7.95192 9.92689 7.71831 9.9885 7.46067L10.0828 7.0664L10.4452 6.93614C10.4561 6.92603 10.4971 6.88571 10.5571 6.77367C10.6466 6.60666 10.7248 6.38047 10.7981 6.12172L10.7985 6.12043C10.8889 5.80309 10.9149 5.57967 10.909 5.43474C10.9055 5.34781 10.8917 5.30828 10.8866 5.29657L10.6584 5.03142L10.7232 4.67869C10.9677 3.34623 10.8075 2.59338 10.5264 2.22079C10.3903 2.04279 10.2423 1.97663 10.1544 1.9488L9.91658 1.87348L9.77124 1.67068C9.67694 1.5391 9.47085 1.29621 9.11238 1.09869L9.10221 1.09308L9.09221 1.08716C8.71857 0.865932 8.29257 0.75 7.80201 0.75C7.71731 0.75 7.62708 0.755036 7.53117 0.761429L7.52407 0.761903L7.51696 0.762242C7.31836 0.771699 7.11764 0.80908 6.9133 0.875252C6.90457 0.878401 6.89485 0.881725 6.88421 0.885081C6.66419 0.96263 6.44134 1.07624 6.2186 1.22823L6.20929 1.23458L6.19979 1.24065C5.93443 1.41026 5.69118 1.61267 5.4819 1.83555L5.47247 1.84559L5.47238 1.8455C5.06033 2.26847 4.80971 2.72216 4.70393 3.18219L4.70119 3.19409L4.69806 3.2059C4.59428 3.59827 4.58738 3.98725 4.67242 4.36993L4.77947 4.85169L4.37939 5.14063L4.37768 5.14194C4.37624 5.14505 4.37405 5.15034 4.37156 5.15847C4.3654 5.17866 4.357 5.21793 4.35544 5.28419C4.35216 5.42327 4.37966 5.63762 4.4692 5.95617L4.46941 5.95691C4.53433 6.18875 4.60102 6.38861 4.6756 6.54586C4.71209 6.62278 4.74554 6.67884 4.77405 6.71789C4.78792 6.73689 4.79922 6.74994 4.80742 6.75843C4.81534 6.76662 4.81954 6.76972 4.81957 6.76974L5.05863 6.94337L5.11502 7.23341C5.19287 7.63378 5.32185 7.98952 5.48951 8.29822L5.58044 8.46565V8.65617V9.44488V9.906L5.16896 10.1141C4.62479 10.3894 3.06636 11.2151 1.54379 12.3997L1.5437 12.3997C1.05069 12.7832 0.75 13.3951 0.75 14.0364V14.8873C0.75 15.0869 0.913491 15.25 1.1127 15.25H14.1542C14.3506 15.25 14.5169 15.0865 14.5169 14.884V14.0331C14.5169 13.3947 14.2159 12.7797 13.7233 12.3966L9.68649 9.90273ZM9.68649 9.90273L10.098 10.1109M9.68649 9.90273L10.098 10.1109M10.098 10.1109C10.6411 10.3856 12.2 11.2147 13.7232 12.3965L10.098 10.1109ZM4.37428 5.14466L4.37436 5.14458C4.3743 5.14464 4.37427 5.14466 4.37428 5.14466ZM6.99628 0.839667C6.9956 0.840008 6.99451 0.840548 6.99333 0.841132L6.99557 0.840024L6.99628 0.839667Z" stroke="white" strokeWidth="1.5" />
                                    </svg>
                                </div>

                                <div className="absolute right-3 top-5 group">
                                    <div className="flex">
                                        {
                                            isToggleLoading === item.user_id._id ?
                                                <div className="flex text-center items-center transition duration-300 ease-out ">
                                                    <Loader />
                                                </div>
                                                :
                                                null
                                        }
                                        <div>
                                            <div onClick={() => { updateStatus(item, index) }} className={`ml-4 md:w-10 md:h-5 w-10 h-5 flex items-center  rounded-full p-1 cursor-pointer   ${item.status === "active" ? "bg-green-600" : "bg-gray-300"}`}>
                                                <div className={`bg-white md:w-3 md:h-3 h-3 w-3 rounded-full shadow-md transform " +  ${item.status === "active" ? toggleClass : null}`}></div>
                                            </div>
                                            <div className="absolute bottom-0 -right-3 flex flex-col items-center hidden mb-6 group-hover:flex">
                                                <span className="relative z-10 p-2 text-xs leading-none text-primary-navyBlue whitespace-no-wrap bg-secondary-blue-500 rounded-md w-16 text-center"> {item.status === "active" ? "Active" : "In active"} </span>
                                                <div className="w-3 h-3 -mt-2 rotate-45 bg-secondary-blue-500"></div>
                                            </div>
                                        </div>


                                    </div>
                                </div>

                            </div>

                            <div className="w-full">

                                <div className="mb-4 pt-1 leading-4">
                                    <h5>
                                        <span className="capitalize text-sm font-semibold text-primary">{item && item.user_id && item.user_id.first_name}&nbsp;{item && item.user_id && item.user_id.last_name}</span>
                                    </h5>
                                    <span className="font-medium mb-1 text-tiny text-greyColor-200 leading-4">
                                        {item && item.user_id && item.user_id.designation && item.user_id.designation.name}
                                    </span>
                                </div>

                                <div className="grid sm:grid-cols-2 gap-2 relative">

                                    <div className="leading-none mb-3">
                                        <h5 className="font-medium text-greyColor-200 leading-4 text-tiny">Email</h5>
                                        <span className="text-tiny font-normal text-primary">{item && item.user_id && item.user_id.email}</span>
                                    </div>

                                    <div className="leading-none mb-3">
                                        <h5 className="font-medium text-greyColor-200 leading-4 text-tiny">Application Role</h5>
                                        {item && item.user_id && item.user_id.roles && item.user_id.roles.length ? item.user_id.roles.map((item, index) =>
                                            <span key={index} className="text-tiny font-normal text-primary">{item.name}</span>
                                        ) : "--"
                                        }
                                    </div>

                                </div>

                                <div className="leading-none mb-4">
                                    <h5 className="font-medium text-greyColor-200 leading-4 text-tiny">Skills</h5>
                                    {item && item.user_id && item.user_id.skills && item.user_id.skills.length ? item.user_id.skills.map((item, index) =>
                                        <span key={index} className="text-tiny font-normal text-primary">{item.name}, </span>
                                    ) : "--"
                                    }
                                </div>

                                <div className="flex ">
                                    {
                                        item && item.user_id && item.user_id.designation && item.user_id.designation.developerstatus &&
                                        <div className="relative inline-block set-activity-btn mr-2 " >
                                            <button disabled={item.status === 'active' ? false : true} type="button" onClick={() => { setSelectedMember(item); handleModal(); }} className="font-title flex items-center border border-primary-navyBlue text-primary-navyBlue text-tiny transition duration-300 ease-out hover:bg-primary-navyBlue hover:text-white h-8 px-2.5 rounded font-medium ">
                                                <span className="mr-1.5">
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.04708 0.0437498C2.90958 0.106249 2.78771 0.231247 2.71897 0.381245C2.66272 0.503119 2.65647 0.590617 2.65647 1.25623V1.99997H2.16899C1.59714 1.99997 1.41902 2.03747 1.04716 2.2281C0.709672 2.40309 0.403435 2.70934 0.228442 3.04684C-0.0184232 3.52495 0.000326034 3.05309 0.000326034 8.99988C0.000326034 14.9467 -0.0184232 14.4748 0.228442 14.9529C0.403435 15.2904 0.709672 15.5967 1.05028 15.7748C1.51901 16.0154 0.972161 15.9998 8 15.9998C15.0278 15.9998 14.481 16.0154 14.9497 15.7748C15.2903 15.5967 15.5966 15.2904 15.7716 14.9529C16.0184 14.4748 15.9997 14.9467 15.9997 8.99988C15.9997 3.05309 16.0184 3.52495 15.7716 3.04684C15.5966 2.70934 15.2903 2.40309 14.9528 2.2281C14.581 2.03747 14.4029 1.99997 13.831 1.99997H13.3435V1.25623C13.3435 0.521869 13.3435 0.509369 13.2654 0.353121C13.2154 0.253121 13.1373 0.159373 13.056 0.106249C12.9279 0.015625 12.9248 0.015625 12.3717 0.00625038C11.7592 -0.00625038 11.678 0.0124998 11.4936 0.209373C11.3342 0.37812 11.3124 0.503119 11.3124 1.28436V1.99997H8H4.68763V1.29373C4.68763 0.521869 4.67201 0.412495 4.52514 0.234372C4.35015 0.0249996 4.25953 0 3.6658 0C3.30019 0.00312519 3.1127 0.015625 3.04708 0.0437498ZM14.6497 10.4436L14.6404 14.1717L14.5529 14.3186C14.4966 14.4154 14.4154 14.4967 14.3185 14.5529L14.1716 14.6404H8H1.82838L1.68151 14.5529C1.58464 14.4967 1.50339 14.4154 1.44714 14.3186L1.35965 14.1717L1.35027 10.4436L1.34402 6.71866H8H14.656L14.6497 10.4436Z" fill="primary-navyBlue" className='fill-current'></path>
                                                    </svg>
                                                </span>
                                                Set availability</button>
                                        </div>
                                    }

                                    <div className="group  mt-1">
                                        {item && item.user_id && item.user_id.availability && item.user_id.availability.length > 0 &&

                                            <span className="text-primary-navyBlue text-tiny font-medium cursor-pointer" >
                                                <svg style={{ width: '20px' }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                                    <path d="M11 10.9794C11 10.4271 11.4477 9.97937 12 9.97937C12.5523 9.97937 13 10.4271 13 10.9794V16.9794C13 17.5317 12.5523 17.9794 12 17.9794C11.4477 17.9794 11 17.5317 11 16.9794V10.9794Z" fill="currentColor" />
                                                    <path d="M12 6.05115C11.4477 6.05115 11 6.49886 11 7.05115C11 7.60343 11.4477 8.05115 12 8.05115C12.5523 8.05115 13 7.60343 13 7.05115C13 6.49886 12.5523 6.05115 12 6.05115Z" fill="currentColor" />
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z" fill="currentColor" />
                                                </svg>
                                            </span>
                                        }
                                        <div className="invisible group-hover:visible absolute rounded-lg max-w-xs flex  flex-wrap justify-center bg-primary-navyBlue p-3 left-1/2 transform -translate-x-1/2 w-full " style={{ bottom: '47px' }}>
                                            {
                                                item && item.user_id && item.user_id.availability && item.user_id.availability.length > 0 &&
                                                item.user_id.availability.map((availabilityitem, ind) => {

                                                    return (
                                                        <div key={ind} className="font-medium text-secondary-blue-300 leading-4 inline-flex flex-col items-center justify-center border rounded p-1 px-2 mr-1 mb-1">
                                                            <span className="block text-center text-lg h-5 font-thin">{moment(availabilityitem.date).format("DD")}</span>
                                                            <span className="block text-center text-small ">{moment(availabilityitem.date).format("MMM")}</span>
                                                        </div>
                                                    )
                                                })
                                            }

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
                    :
                    <div className="text-sm font-medium text-left py-3 text-gray-500">No data</div>
                }
            </div>

            {/* Modal component */}
            <SmallModalLayout closeModal={handleModal} open={open}>
                <MemberAvailability selectedMember={selectedMember} data={data} />
            </SmallModalLayout>

            <TechnologyModalLayout closeModal={handleErrorModal} open={errorOpen}>
                <div className="text-center p-8">
                    <p className="text-sm text-primary">Please remove all allocated dates for the user and then deactivate the user.</p>
                </div>
            </TechnologyModalLayout>

        </>
    )
}


export default Member
